import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration.js';
import reportWebVitals from './reportWebVitals.js';
import analytics from './analytics.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enhanced service worker registration - ENABLED FOR DEVELOPMENT TESTING
serviceWorkerRegistration.register({
  onUpdate: registration => {
    console.log('🔄 App update detected');
    
    // Broadcast update availability to all windows/tabs
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'UPDATE_AVAILABLE'
      });
    }
  },
  onSuccess: registration => {
    console.log('✅ Service worker registered and app ready for offline use');
    
    // Check for updates every 30 minutes (reduced to 5 minutes in development)
    const updateInterval = process.env.NODE_ENV === 'development' ? 5 * 60 * 1000 : 30 * 60 * 1000;
    setInterval(() => {
      if (registration && registration.update) {
        console.log('🔍 Checking for app updates...');
        registration.update();
      }
    }, updateInterval);

    // Trigger audio cache check when app becomes active
    const checkAudioUpdates = () => {
      if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'CHECK_AUDIO_UPDATES'
        });
      }
    };

    // Check for audio updates on page visibility change (app becomes active)
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        console.log('📱 App became visible - triggering audio check');
        checkAudioUpdates();
      }
    });

    // Initial audio check
    checkAudioUpdates();
  },
  onFailure: error => {
    console.error('❌ Service worker registration failed:', error);
    analytics.trackError(error, { context: 'service_worker_registration' });
  }
});

// Track PWA install events
window.addEventListener('beforeinstallprompt', (e) => {
  console.log('📱 PWA install prompt available');
  analytics.trackEvent('pwa_install_prompt_shown');
});

window.addEventListener('appinstalled', () => {
  console.log('📱 PWA installed');
  analytics.trackAppInstall();
});

// Track when app is launched as PWA
if (window.matchMedia('(display-mode: standalone)').matches || 
    window.navigator.standalone === true) {
  analytics.trackEvent('pwa_launched');
}

reportWebVitals();
